<!-- @format -->

<div class="card custom-section">
  <div class="header">
    <div>
      <h1 class="section-title">Add an Admin User</h1>
      <p class="subtext">Fill out the User details using the form below.</p>
    </div>
    <button type="button" class="btn-text" (click)="transferData()">
      Cancel
    </button>
  </div>
  <!-- STEPPER -->
  <div class="custom-stepper">
    <div
      class="custom-stepper__step"
      (click)="setActiveStep(1)"
      [ngClass]="activeStep === 1 ? 'active' : ''"
    >
      <span>STEP 1</span>
      <small>Details</small>
    </div>
    <div
      class="custom-stepper__step"
      (click)="enableNextBtn() || enableBulkNextBtn() ? setActiveStep(2) : null"
      [ngClass]="activeStep === 2 ? 'active' : ''"
    >
      <span>STEP 2</span>
      <small>Client Asignment</small>
    </div>
  </div>

  <!-- STEP 1 -->
  <div *ngIf="activeStep == 1" class="custom-stepper__step1">
      <div class="form-container">
              <div *ngIf="currentRole == Roles.superAdmin">
				<label
					for=""
					class="custom-label required"
					>Account Holder Name</label
				>
        <app-dropdown
          [disabled]="true"
          selectedItem="{{ selectedValues.company.companyName }}"
					label="{{
						selectedValues.company.companyName
					}}"></app-dropdown>
      </div>
      <div>
				<label
					for=""
					class="custom-label required"
					>Client Name</label
				>
        <app-dropdown
          [disabled]="true"
          selectedItem="{{ selectedValues.plant.plantName }}"
					label="{{ selectedValues.plant.plantName }}"></app-dropdown>
      </div>

 <!-- first and last name -->
      
      <div>
				<label
					for="first_name"
					class="custom-label required"
					>First Name</label
				>
        <input
          type="text"
          class="custom-input"
          name="first_name"
          id="first_name"
          minlength="2"
          maxlength="35"
					[(ngModel)]="addAdminRequest.firstName"
          (input)="onFirstNameInput()" />
        <span *ngIf="showFirstNameError" class="unit-error">
          <img class="unit-icon" src="../../assets/error-icon.svg" alt="error" />
          <div class="unit-error-text">{{ firstNameError }}</div>
        </span>
      </div>
      <div>
				<label
					for="last_name"
					class="custom-label required"
					>Last Name</label
				>
        <input
          type="text"
          class="custom-input"
          name="last_name"
          id="last_name"
          minlength="2"
          maxlength="35"
					[(ngModel)]="addAdminRequest.lastName"
          (input)="onLastNameInput()" />
        <span *ngIf="showLastNameError" class="unit-error">
          <img class="unit-icon" src="../../assets/error-icon.svg" alt="error" />
          <div class="unit-error-text">{{ lastNameError }}</div>
        </span>
			</div>

      <!-- email and contact -->

 	      <div>
			<label
				for="email"
				class="custom-label required"
				>Email</label
			>
      <input
        type="email"
        class="custom-input"
        name="email"
        id="email"
        maxlength="320"
        [(ngModel)]="addAdminRequest.username"
        #username="ngModel"
        required
        pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
      />
    </div>
        <div>
      <label for="contact" class="custom-label">Contact Number</label>
      <input
        type="tel"
        class="custom-input"
        name="contact"
        id="contact"
        maxlength="16"
        [(ngModel)]="addAdminRequest.contact"
        (input)="formatContact($event)"
        #contact="ngModel"
      />
    </div>

      </div>

    <!-- Bulk Upload Section -->
    <div class="bulk-upload-section">
      <div class="or-divider">
        <span>OR</span>
      </div>

      <h3 class="bulk-upload-title">Upload Users in bulk</h3>

      <div class="upload-row">
        <input
          type="file"
          #fileInput
          accept=".csv"
          (change)="onFileSelected($event)"
          style="display: none"
        />
        <button
          type="button"
          class="upload-csv-btn"
          (click)="fileInput.click()"
        >
          <img src="../../assets/upload.svg" alt="upload" class="upload-icon" />
          Upload CSV File
        </button>
        <div
          class="upload-status"
          [ngClass]="{ placeholder: !showUploadStatus }"
        >
          <div class="upload-status__row">
            <span class="upload-filename">{{ uploadedFileName }}</span>
            <span class="upload-percent">
              {{
                uploadStatus === "complete" ? "Complete" : uploadProgress + "%"
              }}
            </span>
          </div>
          <div class="upload-progress">
            <div
              class="upload-progress__bar"
              [ngClass]="{ complete: uploadStatus === 'complete' }"
              [style.width.%]="uploadProgress"
            ></div>
          </div>
        </div>
      </div>

      <p class="csv-cta">
        Not sure what to include? Download our
        <span class="csv-cta__link" (click)="downloadSampleCsv()"
          >Sample CSV file</span
        >.
      </p>

      <!-- Validation Message -->
      <div
        *ngIf="validationMessage"
        class="validation-message"
        [ngClass]="csvValidated ? 'success-message' : 'error-message'"
      >
        {{ validationMessage }}
      </div>
    </div>
  </div>

  <!-- STEP 2 -->
  <div *ngIf="activeStep == 2" class="custom-stepper__step2">
    <div class="custom-stepper__step2-container">
      <!-- SECTION 1 -->
      <div class="section1">
        <div class="mr-28">
          <h3>Available Client Assignments</h3>
          <p class="instructions">
            Select checkbox to Client to current Client Assignments
          </p>
        </div>
        <div class="search-bar mr-28">
          <img src="../assets/search.svg" alt="search" />
          <input type="text" placeholder="Search" [(ngModel)]="searchText" />
        </div>
        <!-- PLANTS -->
        <div class="data-list" *ngIf="activePlants.length > 0">
          <app-checked-card
            *ngFor="
              let data of activePlants | search: searchText : 'plantName';
              let i = index
            "
            [attr.data-index]="i"
            [title]="data?.plantName"
            (onClickIcon)="isSelectedPlant(data) ? null : addPlant(data)"
            [isSelected]="isSelectedPlant(data)"
            [icon]="
              isSelectedPlant(data)
                ? 'checkbox-selected.svg'
                : 'checkbox-unselected.svg'
            "
          ></app-checked-card>
        </div>
      </div>
      <!-- SECTION 2 -->
      <div class="section2">
        <h3>Current Client Assignments</h3>
        <ul>
          <li class="instructions">Click “X” to remove a Client</li>
        </ul>
        <!-- SELECTED PLANTS -->
				<div
					class="data-list"
					*ngIf="selectedPlants.length > 0">
          <app-checked-card
            *ngFor="let data of selectedPlants; let i = index"
            [attr.data-index]="i"
            [title]="data?.plantName"
            [isSelected]="true"
            (onClickIcon)="removePlant(i)"
						icon="checkbox-remove.svg"></app-checked-card>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!errorMessage.success" class="error">
    <img src="../../assets/alert.svg" alt="" />
    <p>
      {{ errorMessage.message }}
    </p>
  </div>

  <!-- Bulk Upload Results (Step 2) -->
  <div
    *ngIf="activeStep == 2 && showBulkUploadResults && bulkUploadResults"
    class="bulk-results"
  >
    <h4>Upload Results</h4>
    <p>Total Processed: {{ bulkUploadResults.totalProcessed }}</p>
    <p class="success-text">Successful: {{ bulkUploadResults.successCount }}</p>
    <p class="error-text" *ngIf="bulkUploadResults.failedCount > 0">
      Failed: {{ bulkUploadResults.failedCount }}
    </p>
    <div *ngIf="bulkUploadResults.failedCount > 0" class="failed-users">
      <p><strong>Failed registrations:</strong></p>
      <ul>
        <li *ngFor="let result of bulkUploadResults.results">
          <span *ngIf="!result.success"
            >{{ result.email }}: {{ result.message }}</span
          >
        </li>
      </ul>
    </div>
  </div>
	<div
		*ngIf="!errorMessage.success"
		class="error">
		<img
			src="../../assets/alert.svg"
			alt="" />
    <p>
      {{ errorMessage.message }}
    </p>
  </div>

  <div class="step__btn-group">
    <button
      type="button"
      class="btn-outline"
      (click)="activeStep == 1 ? transferData() : setActiveStep(1)"
    >
      Back
    </button>
    <!-- Step 1 Next button -->
    <button
      *ngIf="activeStep == 1"
      [ngClass]="
        !(enableNextBtn() || enableBulkNextBtn()) ? 'disabled-btn' : ''
      "
      [disabled]="!(enableNextBtn() || enableBulkNextBtn())"
      (click)="setActiveStep(2)"
      type="button"
      class="btn-fill"
    >
      Next
    </button>
    <!-- Step 2 Add Single User button -->
    <button
      *ngIf="activeStep == 2 && !isBulkMode"
      [ngClass]="selectedPlants.length === 0 ? 'disabled-btn' : ''"
      [disabled]="selectedPlants.length === 0"
      (click)="showSaveModal()"
      type="submit"
      class="btn-fill"
    >
      Add User
    </button>
    <!-- Step 2 Bulk Upload button -->
    <button
      *ngIf="activeStep == 2 && isBulkMode"
      [ngClass]="selectedPlants.length === 0 ? 'disabled-btn' : ''"
      [disabled]="selectedPlants.length === 0"
      (click)="submitBulkAdminUsers()"
      type="button"
      class="btn-fill"
    >
      Upload {{ bulkUsers.length }} Users
    </button>
  </div>
</div>
<app-success-toast *ngIf="toastService.showToast"></app-success-toast>
<app-save-modal
  *ngIf="addAdmin"
  (closeModal)="closeModal()"
  (onSave)="addAdminUser()"
></app-save-modal>
